function Todo(id, title = '', done = false) {
  this.id = id;
  this.title = title;
  this.done = done;
}

export default Todo;



// WEBPACK FOOTER //
// ./src/dataControl/model/todo.js